import * as Sentry from "@sentry/react";
import { Component } from "react";
import type { ErrorInfo, PropsWithChildren } from "react";

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-dvh items-center justify-center bg-background px-4">
        <div className="text-center">
          <div className="mx-auto flex size-14 items-center justify-center rounded-full bg-danger/10 text-danger">
            <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          </div>
          <p className="mt-4 text-base font-semibold">Something went wrong</p>
          <p className="mt-1 text-sm text-muted-foreground max-w-xs mx-auto">
            Your data is safe. Reload the app to continue.
          </p>
          <button type="button" className="btn-primary mt-5" onClick={() => window.location.reload()}>
            Reload TailorBook
          </button>
        </div>
      </div>
    );
  }
}
